import { combineReducers } from '@reduxjs/toolkit';

import policyManagerSlice from './rules';

export const rootReducer = combineReducers({
  policyManager: policyManagerSlice,
});
